var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",attrs:{"justify":"center"}},[_c('Carts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }